import { render, staticRenderFns } from "./QuanLyVanBanList.vue?vue&type=template&id=5fad19e2"
import script from "./QuanLyVanBanList.vue?vue&type=script&lang=js"
export * from "./QuanLyVanBanList.vue?vue&type=script&lang=js"
import style0 from "./QuanLyVanBanList.vue?vue&type=style&index=0&id=5fad19e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports